import { override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';

import { dismissalIsActive, storeDismissal } from './welcomeHeroDismissalState';

export default function configureWelcomeHeroDismissal() {
  override(WelcomeHero.prototype, 'oninit', function (original, vnode) {
    original(vnode);

    const isHomePage = app.current.get('routeName') === 'index';
    this.hidden = !isHomePage || dismissalIsActive();
  });

  override(WelcomeHero.prototype, 'hide', function () {
    this.hidden = true;
    storeDismissal();
  });

  override(WelcomeHero.prototype, 'isHidden', function () {
    const title = app.forum.attribute('welcomeTitle');

    return !title || !title.trim() || this.hidden;
  });
}
